var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer"},[_c('div',{staticClass:"timer-value"},[_vm._v(" "+_vm._s(_vm.currentTime)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }